var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal fade"tabindex="-1"role="dialog"> <div class="modal-dialog"data-bind="css: options.css"> <div class="modal-content"data-bind="template: options.template"></div> </div> </div>';
}
return __p;
};
